import { useState } from "react";
import { Crown, Flag as FlagIcon } from "lucide-react";
import { initials } from "../lib/data";

export const RED = "#e5484d";

export function RedFlagIcon({ size = 14, testId = "red-flag-icon", className = "" }) {
  return <FlagIcon size={size} data-testid={testId} className={`shrink-0 ${className}`} style={{ color: RED }} fill={RED} aria-label="Red flag" />;
}

export function Avatar({ nombre, src, size = 56, coronada = false, redFlag = false, testId }) {
  const [failed, setFailed] = useState(false);
  const dim = { width: size, height: size };
  return (
    <div className="relative shrink-0" style={dim} data-testid={testId}>
      {src && !failed ? (
        <img src={src} alt="" onError={() => setFailed(true)} className="rounded-full object-cover w-full h-full border border-border" style={dim} />
      ) : (
        <div className="rounded-full w-full h-full flex items-center justify-center bg-secondary border border-border font-display font-medium text-muted-foreground"
          style={{ ...dim, fontSize: size * 0.36 }}>
          {initials(nombre) || "?"}
        </div>
      )}
      {coronada && (
        <span data-testid="avatar-crown" className="absolute -top-1 -right-1 bg-[#0b0c0e] rounded-full p-0.5 gold-glow">
          <Crown size={Math.max(14, size * 0.3)} className="text-[#d4af37]" fill="#d4af37" />
        </span>
      )}
      {redFlag && (
        <span data-testid="avatar-red-flag" className="absolute -bottom-1 -right-1 bg-[#0b0c0e] rounded-full p-0.5" style={{ boxShadow: `0 0 8px ${RED}99` }}>
          <RedFlagIcon size={Math.max(12, size * 0.26)} testId="avatar-red-flag-icon" />
        </span>
      )}
    </div>
  );
}

export function Flag({ iso, size = 20 }) {
  const [failed, setFailed] = useState(false);
  if (!iso) return null;
  if (failed) {
    return <span style={{ fontSize: size * 0.9 }}>{String.fromCodePoint(...iso.toUpperCase().split("").map((c) => 127397 + c.charCodeAt(0)))}</span>;
  }
  return <img src={`https://flagcdn.com/w40/${iso.toLowerCase()}.png`} width={size} height={Math.round(size * 0.75)} alt={iso}
    onError={() => setFailed(true)} className="inline-block rounded-[2px] object-cover" style={{ width: size, height: Math.round(size * 0.75) }} />;
}
